// This file is ignored by prettier

import React, { useEffect, useState } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'

// Prime Chart.js to use annotation plugin
import {
  Chart,
  LineElement,
  PointElement,
  LineController,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js'
import annotationPlugin from 'chartjs-plugin-annotation'
Chart.register(
  LineElement,
  PointElement,
  LineController,
  BarElement,
  BarController,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
)

import Footer from 'js/components/Footer'
import Header from 'js/components/Headers/AuthorizedHeader'
import OrganizationDeniedWarn from 'js/components/HelpMessages/OrganizationDeniedWarn'
import Loader from 'js/components/Loader'

import AdminControlTypeDetail from 'js/containers/AdminControlTypeDetail'
import AdminControlTypes from 'js/containers/AdminControlTypes'
import AdminDeviceDetail from 'js/containers/AdminDeviceDetail'
import AdminDevices from 'js/containers/AdminDevices'
import AdminDeviceTypes from 'js/containers/AdminDeviceTypes'
import AdminLotGroupDetail from 'js/containers/AdminLotGroupDetail'
import AdminLotGroups from 'js/containers/AdminLotGroups'
import AdminOrganizationDetail from 'js/containers/AdminOrganizationDetail'
import AdminOrganizations from 'js/containers/AdminOrganizations'
import AdminSiteDetail from 'js/containers/AdminSiteDetail'
import AdminUserDetail from 'js/containers/AdminUserDetail'
import AdminUsers from 'js/containers/AdminUsers'
import ControlRunDetail from 'js/containers/ControlRunDetail'
import ControlRuns from 'js/containers/ControlRuns'
import CorrectiveActionForm from 'js/containers/CorrectiveActionForm'
import Help from 'js/containers/Help'
import PrivacyPolicy from 'js/containers/PrivacyPolicy'
import Profile from 'js/containers/Profile'
import SubmitData from 'js/containers/SubmitData'

import { User } from 'js/models'
import { getSelf } from 'js/services/user'

import { ApprovedStatus } from 'js/utils/constants'
import { SelfUser } from 'js/utils/helpers'
import Paths from 'js/utils/paths'
import VQCPermissions from 'js/utils/permissions'

function AuthorizedMain(): React.ReactElement {
  const [myUser, setMyUser] = useState<User>()

  useEffect(() => {
    getSelf().then(r => setMyUser(r))
  }, [])

  if (!myUser) return <Loader />

  const deniedAccess = myUser.organizationDetails?.approvedStatus == ApprovedStatus.denied && !VQCPermissions.isSuperAdmin(myUser)

  return (
    <Router>
      <SelfUser.Provider value={myUser}>
        <div id='app'>
          <Header />
          <div id='maincontent' className='container'>
            {deniedAccess ? <OrganizationDeniedWarn user={myUser}/> :
            <Routes>
              <Route path={Paths.controlRuns} element={<ControlRuns />} />
              <Route path={Paths.controlRunDetail} element={<ControlRunDetail />} />
              <Route path={Paths.controlRunReport} element={<ControlRunDetail />} />
              <Route path={Paths.profile} element={<Profile />} />
              <Route path={Paths.privacyPolicy} element={<PrivacyPolicy />} />
              <Route path={Paths.submitData} element={<SubmitData />} />
              <Route path={Paths.adminControlTypes} element={<AdminControlTypes />} />
              <Route path={Paths.adminControlTypeDetail} element={<AdminControlTypeDetail />} />
              <Route path={Paths.adminDeviceTypes} element={<AdminDeviceTypes />} />
              <Route path={Paths.adminDevices} element={<AdminDevices />} />
              <Route path={Paths.adminDeviceDetail} element={<AdminDeviceDetail />} />
              <Route path={Paths.adminSiteDetail} element={<AdminSiteDetail />} />
              <Route path={Paths.adminUsers} element={<AdminUsers />} />
              <Route path={Paths.adminUserDetail} element={<AdminUserDetail />} />
              <Route path={Paths.adminLotGroups} element={<AdminLotGroups />} />
              <Route path={Paths.adminLotGroupDetail} element={<AdminLotGroupDetail />} />
              <Route path={Paths.adminOrganizations} element={<AdminOrganizations />} />
              <Route path={Paths.adminOrganizationDetail} element={<AdminOrganizationDetail />} />
              <Route path={Paths.help} element={<Help />} />
              <Route path={Paths.correctiveActionForm} element={<CorrectiveActionForm />} />
              {/* Default Route */}
              <Route path='/' element={<ControlRuns />} />
              <Route path='*' element={<ControlRuns />} />
            </Routes>
            }
          </div>
          <Footer />
        </div>
      </SelfUser.Provider>
    </Router>
  )
}

export default AuthorizedMain
